import React from 'react'
import Styles from "./EmailVerify.module.css"

function EmailVerificationModal({ verifyEmail}) {
    return (
        <>
            <div className={verifyEmail ? Styles.verify_container_active : Styles.verify_container}>
                <div className={Styles.verify_box}>
                    <p className={Styles.p1}>Barnaslunsj.n</p>
                    <p className={Styles.p2}>Verify your email address</p>
                    <p className={Styles.p3}>Please confirm that you want to use this as your Barnaslunsj account email address</p>
                </div>
            </div>
        </>
    )
}

export default EmailVerificationModal
